module.exports = __webpack_public_path__ + "media/Mantraz_Web_720p.0a67d643.webm";